import { HeaderNavigationProps } from "@/components/HeaderNavigation";
import * as Schema from "../types/schema";
import { excludeDraftsFilter } from "./filters";
import { FooterNavigationProps } from "@/components/FooterNavigation/query";
export type PrivacyPolicyData = Pick<
  Schema.PrivacyPolicy,
  "_id" | "pageFeatureFlag" | "heading" | "subHeading" | "bodyRichText"
> &
  HeaderNavigationProps & { footerPayload: FooterNavigationProps };

export const getPrivacyPolicyQuery = (preview?: boolean) => `
  *[_type == "privacyPolicy"${!preview ? ` && ${excludeDraftsFilter}` : ""}]{
    _id,
    pageFeatureFlag,
    heading,
    subHeading,
    bodyRichText 
  }
`;
